import { isElement, isUndefined } from 'lodash';
import forEach from 'lodash/forEach';

import { getSessionStorage, setSessionStorage } from '../../01-helpers/session-manager';

const moduleName = 'popup',
    selectors = {
        base: `.js-${moduleName}`,
        closeButton: `.js-${moduleName}__close`
    },
    className = {
        hide: 'u-hide',
        show: 'u-show'
    };

export default class Popup {
    constructor(baseElement) {
        if (!isElement(baseElement)) {
            return false;
        }

        this._id = !isUndefined(baseElement.dataset.ctaId) ? baseElement.dataset.ctaId : "golfnl";

        this._config(baseElement);
        this._setup();
    }

    _showPopup() {
        // check for the session storage
        const sessionStorage = getSessionStorage(`ctapopup-${this._id}`);
        // if the popup has not been closed before, than show popup
        if (!sessionStorage?.hide) {
            this.element.classList.remove(className.hide);
            this.element.classList.add(className.show);
        }        
    }

    _onClickHandler(ev) {
        ev.preventDefault();
        const trigger = ev.currentTarget;
        // hide the popup
        this.element.classList.remove(className.show);
        this.element.classList.add(className.hide);
        // set the sessions storage to prevent the popup being shown this session
        setSessionStorage(
            `ctapopup-${this._id}`,
            { 'hide': true }
        );

        if (!isUndefined(trigger.href)) {
            window.open(trigger.href, trigger.target);
        }
    }

    _bindEvents() {
        forEach(this.closeButtons, closeButton => {
            closeButton.addEventListener('click', (event) => this._onClickHandler(event));
        })
        
    }

    _config(element) {
        this.element = element;
        this.closeButtons = element.querySelectorAll(selectors.closeButton);
    }

    _setup() {
        this._bindEvents();
        this._showPopup();
    }
}

function initPopup(baseElements = document.querySelectorAll(selectors.base)) {
    forEach(baseElements, baseElement => {
        new Popup(baseElement);
    });
}

initPopup();